import module from '../module';
import * as _ from 'lodash';
import moment from 'moment';

function OrderTabFinishController($scope, cartonomyConfig, userProfile, session, groupOrderService) {

    session.getUserName().then((ownerEmail) => {
        $scope.orderOwnerEmail = ownerEmail;
    })
    $scope.orderOwnerName = $scope.orderOwnerEmail;
    $scope.externalStoreMode = cartonomyConfig.externalStoreMode;

    $scope.configuration = {
        groupPay: groupOrderService.getGroupPay(),
        singlePayOrder: groupOrderService.getSinglePayOrder(),
        deliveryDetails: groupOrderService.getDeliveryDetails()
    };

    $scope.deadlineTime = moment($scope.configuration.deliveryDetails.deadlineTime).format('LT [on] MMMM D, YYYY');

    if (moment($scope.configuration.deliveryDetails.deadlineTime).isValid()) {
        $scope.deadlineTimeText = moment($scope.configuration.deliveryDetails.deadlineTime).format('LT [on] MMMM D, YYYY');
    }

    userProfile.getUser().then(function (user) {
        $scope.orderOwnerName = _.trim(user.firstName + ' ' + user.lastName);
    });
}

module.controller('OrderTabFinish', ['$scope', 'cartonomyConfig', 'UserProfile', 'Session', 'GroupOrder', OrderTabFinishController]);


// WEBPACK FOOTER //
// ./src/modules/order/controllers/OrderTabFinishController.js